import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const fishHawkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Fish Hawk Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Fish Hawk, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_fish_hawk',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Fish Hawk',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Fish Hawk Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the premier planned communities 
     of <strong>Fish Hawk</strong> with professional tree care that matches the 
     standards of this sought after Hillsborough County neighborhood. Beautifully 
     landscaped properties, conservation lots, and maturing trees throughout the 
     community all require expert management especially as Florida's storm 
     seasons become more intense.`,

    `We specialize in <strong>precision tree removal and canopy management in 
     upscale planned communities</strong> storm damaged trees near luxury homes 
     and pools, large limb overhangs threatening rooftops and driveways, canopy 
     thinning that reduces storm risk while preserving your landscape's beauty, 
     and careful removals on conservation bordered lots. We respect your 
     property inside and out.`,

    `<strong>Sam's Tree Service</strong> delivers expert, trusted tree care 
     throughout <strong>Fish Hawk</strong> and the surrounding 
     <strong>Southeast Hillsborough</strong> communities keeping your 
     home safe and your landscape in top condition all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Fish Hawk, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_FishHawk = () => <LocationPage config={fishHawkConfig} />;
export default Services_FishHawk;
